<template>
  <DiscountCampaignForm />
</template>

<script>
import DiscountCampaignForm from './DiscountCampaignForm.vue';

export default {
  name: 'DiscountCampaignCreate',
  components: { DiscountCampaignForm },
};
</script>
